import type { NewUserQuizCopy } from '../types';

export const IT_NEW_USER_QUIZ_COPY = {
  booking: {
    backToVideo: 'Torna al tuo video',
    bookedSnackbar: 'La tua demo è prenotata — a presto!',
    bullets: {
      pricing: 'Prezzi chiari in base al volume e al livello di assistenza',
      teams: 'Pensato per i team: revisori, glossari e un’unica libreria',
      setup: 'Scopri la configurazione giusta per i tuoi contenuti e il tuo flusso di lavoro',
    },
    confirmation: {
      title: 'La tua demo è prenotata',
      description:
        'Ti abbiamo inviato un invito di calendario via email. La tua anteprima localizzata resta disponibile e condivisibile prima della call.',
    },
    continue: 'Continua',
    decision: {
      bookDemo: {
        title: 'Prenota una demo',
        buttonLabel: 'Prenota una demo',
        description:
          'Esamina con uno specialista gli spazi di lavoro del team, le API e il doppiaggio su larga scala, e definisci come integrare Rask nel tuo flusso.',
      },
      exploreEditor: {
        title: "Esplora nell'editor",
        buttonLabel: "Apri l'editor",
        description: 'Perfeziona autonomamente copione, voci e sincronizzazione. Durante la prova è tutto sbloccato.',
      },
    },
    description: 'Configura Rask in base ai tuoi contenuti, al tuo team e ai tuoi volumi.',
    followUp: {
      callAgenda: [
        "Una rapida occhiata all'anteprima che hai creato",
        'Il tuo flusso di lavoro, i volumi e il piano di lancio',
        "Configuriamo l'editor in base al tuo flusso di lavoro",
      ],
      callDescription: "Controlla nell'invito di calendario la data, l'ora e il link confermati.",
      callDurationLabel: (minutes) => `Videochiamata di ${minutes} minuti`,
      callTitle: 'La tua call',
      manageBooking: {
        title: 'Gestisci la prenotazione',
        buttonLabel: 'Gestisci prenotazione',
        closeLabel: 'Chiudi',
        description:
          "Per spostare o annullare l'incontro, apri l'evento nel calendario aziendale e usa le opzioni presenti nell'invito.",
        googleCalendarLabel: 'Apri Google Calendar aziendale',
        outlookCalendarLabel: 'Apri il calendario aziendale di Outlook',
      },
      prepareDescription:
        'Invita i colleghi e annota le modifiche a testo, voce o sincronizzazione che vuoi discutere.',
      prepareTitle: 'Preparati alla call',
      share: {
        title: 'Condividi questa anteprima con il tuo team',
        buttonLabel: 'Condividi',
        copiedButtonLabel: 'Copiato!',
        copyButtonLabel: 'Copia',
        description: 'Invia al team l’anteprima localizzata, così tutti potranno arrivare con osservazioni utili.',
        modalDescription: 'Invia il tuo video a chi vuoi usando il link qui sotto',
        modalTitle: 'Condividi il tuo video',
      },
      videoCallLabel: 'Videochiamata',
    },
    heading: 'Prenota la tua call di configurazione',
    headingSecondLine: '',
    maybeLater: 'Forse più tardi',
    persistenceError: 'Non siamo riusciti a salvare questo passaggio. Seleziona «Continua» per riprovare.',
    rating: '4,7/5 su G2',
    scheduler: {
      fallbackBookedLabel: 'Ho prenotato un appuntamento',
      openBookingPage: 'Apri la pagina di prenotazione',
      loadErrorDescription:
        'La tua rete o la tua area geografica potrebbe bloccare il contenuto incorporato. Apri invece la pagina di prenotazione in una nuova scheda.',
      loadErrorTitle: 'Impossibile caricare il calendario',
      loadingLabel: 'Caricamento del calendario',
    },
    trustedBy: 'Scelto da team in tutto il mondo',
    verificationPending: {
      title: 'Stiamo confermando la prenotazione',
      description: 'Stiamo verificando i dettagli della riunione con HubSpot. Potrebbero volerci alcuni istanti.',
    },
  },
  controls: {
    back: 'Indietro',
    continue: 'Continua',
    continueAnyway: 'Continua comunque',
    progress: (currentStep, totalSteps) => `Domanda ${currentStep} di ${totalSteps}`,
    submitError: 'Non è stato possibile salvare le tue risposte. Riprova.',
  },
  priorityQuestion: {
    title: 'Qual è la tua priorità nella localizzazione in questo momento?',
    audioTitle: 'Qual è la tua priorità nella localizzazione in questo momento?',
    options: {
      collaborate_with_team_or_reviewers: { label: 'Controllo qualità e flusso di lavoro' },
      consistent_voice_and_terminology: { label: 'Voce e terminologia coerenti' },
      fast_results_no_setup: { label: 'Lavoro individuale semplice e rapido' },
      integration_into_product_or_workflow: { label: 'Integrazione e conformità' },
      not_sure_yet: { label: 'Non lo so ancora' },
    },
    subtitle: "Scegli un'opzione",
  },
  questions: {
    content_team_size: {
      title: 'Quante persone del tuo team lavorano con contenuti video?',
      options: {
        just_me: { label: '1' },
        large_team_5_plus: { label: '8+' },
        small_team_2_5: { label: '2-7' },
      },
    },
    localization_frequency: {
      title: 'Con quale frequenza localizzi video?',
      audioTitle: 'Con quale frequenza localizzi contenuti?',
      options: {
        continuously: { label: 'Ho una necessità costante' },
        occasionally_quarterly: { label: 'Occasionalmente' },
        regularly_monthly: { label: 'Regolarmente', description: 'Ogni mese' },
        one_time_project: { label: 'Ho un incarico una tantum' },
      },
    },
  },
} satisfies NewUserQuizCopy;
